interface SectionContentProps {
  children: React.ReactNode;
}

export const SectionContent = ({ children }: SectionContentProps) => {
  return (
    <div className="flex flex-col sm:flex-col overflow-y-auto h-full">
      {children}
    </div>
  );
};
